export class ApiResponseError extends Error {
  constructor(message?: string) {
    super(message || 'عملیات ناموفق بود.');
    this.name = 'ApiResponseError';
  }
}

export const assertApiSuccess = <T extends { isSuccess?: boolean; message?: string }>(response: T) => {
  if (response?.isSuccess === false) throw new ApiResponseError(response.message);
  return response;
};
